import {
    createContext,
    lazy,
    useCallback,
    useContext,
    useState,
    type FC,
    type ReactNode,
} from 'react';

import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';

import { TradeBenefitsInReviewModal } from '../nonTrade/TradeBenefitsInReviewModal.tsx';

type ApplyHandler = () => Promise<void>;

const noop: ApplyHandler = async () => {};

const TradeApplyHandlerContext = createContext<ApplyHandler>(noop);

export const useTradeApplyHandler = (): ApplyHandler => useContext(TradeApplyHandlerContext);

const TradeApplyHandlerLoader = lazy(
    () => import(/* webpackChunkName: "TradeApplyHandlerLoader" */ './TradeApplyHandlerLoader.tsx')
);

export const TradeApplyHandlerProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [handler, setHandler] = useState<ApplyHandler>(() => noop);
    const [isInReviewModalOpen, setIsInReviewModalOpen] = useState(false);

    const onReady = useCallback((next: ApplyHandler) => {
        setHandler(() => next);
    }, []);

    const onInReviewApply = useCallback(() => {
        setIsInReviewModalOpen(true);
    }, []);

    return (
        <TradeApplyHandlerContext value={handler}>
            <ClientSuspense fallback={null}>
                <TradeApplyHandlerLoader onReady={onReady} onInReviewApply={onInReviewApply} />
            </ClientSuspense>
            {children}
            {isInReviewModalOpen ? (
                <TradeBenefitsInReviewModal onClose={() => setIsInReviewModalOpen(false)} />
            ) : null}
        </TradeApplyHandlerContext>
    );
};
